document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bulk_order').forEach(initBulkOrder);
});

function initBulkOrder(root) {
  if (!root || root.dataset.initialized) return;

  const openBtn = root.querySelector('.bulk_order_btn');
  const overlay = root.querySelector('.bulk_order_overlay');
  if (!openBtn || !overlay) return;

  const closeBtn = overlay.querySelector('.icon-close');
  const addToCartBtn = overlay.querySelector('.bundle_atc');

  const originalParent = overlay.parentNode;
  const originalNextSibling = overlay.nextSibling;

  // ===== OPEN / CLOSE =====
  openBtn.addEventListener('click', () => {
    openOverlay();
    updateTotal();
  });

  closeBtn?.addEventListener('click', closeOverlay);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeOverlay();
  });

  function openOverlay() {
    if (!overlay.dataset.teleported) {
      document.body.appendChild(overlay);
      overlay.dataset.teleported = 'true';
    }

    overlay.classList.add('open');
    document.body.classList.add('no-scroll');
  }

  function closeOverlay() {
    overlay.classList.remove('open');
    document.body.classList.remove('no-scroll');

    if (overlay.dataset.teleported && originalParent) {
      if (originalNextSibling) {
        originalParent.insertBefore(overlay, originalNextSibling);
      } else {
        originalParent.appendChild(overlay);
      }
      delete overlay.dataset.teleported;
    }
  }

  // ===== QUANTITY HANDLING =====
  overlay.querySelectorAll('.product_container').forEach(container => {
    const minus = container.querySelector('button:first-child');
    const plus = container.querySelector('button:last-child');
    const input = container.querySelector("input[name='quantity']");
    const max = parseInt(input?.max) || Infinity;

    container.addEventListener('click', (e) => {
      if (e.target.closest('input, button, select, textarea')) return;
    
      window.location.href = container.dataset.url;
    });

    minus?.addEventListener('click', (e) => {
      input.value = Math.max(0, (parseInt(input.value) || 0) - 1);
      updateTotal();
    });

    plus?.addEventListener('click', (e) => {
      const val = parseInt(input.value) || 0;
      if (val < max) input.value = val + 1;
      updateTotal();
    });

    input?.addEventListener('input', (e) => {
      if (parseInt(input.value) > max) input.value = max;
      updateTotal();
    });
  });

  // ===== TOTALS =====
  function updateTotal() {
    let totalItems = 0;
    let totalPrice = 0;

    overlay.querySelectorAll('.product_container').forEach(container => {
      const input = container.querySelector("input[name='quantity']");
      const qty = parseInt(input?.value) || 0;
      const price = parseFloat(
        container.querySelector('.price')?.dataset.price || 0
      );

      totalItems += qty;
      totalPrice += qty * price;
    });

    overlay.querySelector('.total_bundle_items span').textContent = totalItems;
    overlay.querySelector('.total_bundle_price span').textContent =
      Shopify.formatMoney(totalPrice * 100);

    addToCartBtn.querySelector('.atc-button--quantity').textContent = `(${totalItems})`;
    addToCartBtn.disabled = totalItems === 0;
  }

  // ===== ADD TO CART =====
  addToCartBtn?.addEventListener('click', () => {
    const items = [];

    overlay.querySelectorAll('.product_container').forEach(container => {
      const qty = parseInt(
        container.querySelector("input[name='quantity']")?.value
      ) || 0;

      if (qty > 0) {
        const item = {
          id: container.dataset.variantId,
          quantity: qty
        };

        // Variants without an MSRP get no property
        if (container.dataset.msrp) {
          item.properties = { MSRP: container.dataset.msrp };
        }

        items.push(item);
      }
    });

    if (!items.length) return;

    addToCartBtn.classList.add('processing');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(() => {
        closeOverlay();
        window.location.href = '/cart';
      })
      .finally(() => addToCartBtn.classList.remove('processing'));
  });

  root.dataset.initialized = 'true';
}

// ===== QUICKSHOP INIT =====
document.addEventListener('bulkorder:init', (e) => {
  const root = e.detail.root;
  initBulkOrder(root);
});
